import Event from '../../core/Event';

export default class DataExportFailed extends Event {
    public static type = 'DataExportFailed';

    constructor() {
        super(DataExportFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/DataExportFailed.ts